import { computeLineTotal, roundResult } from '../calculations'
import { InvoiceLine, InvoiceLinePrice } from '../type'

interface LineUpdateParams {
  line: InvoiceLine
  targetName: keyof InvoiceLinePrice
  targetValue: number
}

export const handleLineCalculation = ({
    line,
    targetName,
    targetValue,
  }: LineUpdateParams): InvoiceLine => {
    const newLine: InvoiceLine = { ...line }
  
    // Always apply rounding to the target field
    const roundedValue = roundResult(targetValue)
    newLine[targetName] = roundedValue
  
    // Special case: if user edits unitPriceInclVat, reverse-calculate unitPrice
    if (targetName === 'unitPriceInclVat') {
          newLine.unitPriceInclVat = roundedValue // preserve what user typed
        if (1 + newLine.vat / 100 !== 0) {
            const baseUnitPrice = roundedValue / (1 + newLine.vat / 100)
            newLine.unitPrice = roundResult(baseUnitPrice)
           newLine.lineTotal = computeLineTotal(newLine, true)
          } else {
            newLine.lineTotal = 0
          }
    }
    else {
      newLine.lineTotal = computeLineTotal(newLine, false)
    }


    return newLine
  }
